import { createContext, useContext } from 'react';

// Lets any page header render the phone's avatar button (ProfileButton) that
// opens the single Perfil sheet owned by App — Configuración, Inversiones and
// Cerrar sesión, which don't fit in the five-tab bottom bar.
export const ProfileMenuContext = createContext({ openProfileMenu: () => {}, photo: '' });

export const useProfileMenu = () => useContext(ProfileMenuContext);
